export default function setLocale({ props: { locale }, state }) {
  state.set('locale', locale);
}



// WEBPACK FOOTER //
// ./app/actions/setLocale.js